import { GridColumnVisibilityModel, GridFilterModel, GridSortModel, useGridApiRef } from '@mui/x-data-grid-premium'
import { useEntitiesFromSearch } from 'api/search'
import { useOrganizationView } from 'api/aws/organizations_table/useOrganizationView'
import ProductInfoDialog from 'components/ProductRows/ProductInfoDialog'
import { renderProductsColumns } from 'components/ProductRows/renderProductsColumns'
import GlobalDataGrid from 'components/DataGrid/GlobalDataGrid'
import { useLayoutContext } from 'context/LayoutProvider/LayoutProvider'
import dayjs from 'dayjs'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { OrganizationTableItem, Product } from 'types'
import { gridContainerStyles } from './style'
const defaultSortModel: GridSortModel = [{ field: 'name', sort: 'asc' }]
const defaultFilterModel: GridFilterModel = {
  items: [],
  quickFilterValues: [],
}
export const defaultVisibilityModel: GridColumnVisibilityModel = {
  id: false,
  __newStatus: false,
  deal_end_date: false,
  contracted_by: false,
  category_name: false,
  subcategory: false,
}
const DEFAULT_DENSITY = 'standard'
const OrgProducts = () => {
  const { PK } = useParams()
  const { pinned } = useLayoutContext()
  const [selectedItem, setSelectedItem] = useState(null)
  const [infoOpen, setInfoOpen] = useState(false)
  const { viewProducts, isParent } = useOrganizationView(PK)
  const { organizations, deals } = useEntitiesFromSearch()
  const apiRef = useGridApiRef()
  const formatDateString = date => {
    if (!date) return ''
    return dayjs.isDayjs(date) ? date.format('MM/DD/YYYY') : dayjs(date).format('MM/DD/YYYY')
  }
  const products = useMemo(() => {
    if (!viewProducts || !viewProducts?.length) return []
    return (
      viewProducts?.map((p: Product) => {
        return { ...p, rowId: `${p?.SK}` }
      }) ?? []
    )
  }, [viewProducts])
  const openInfo = (product: OrganizationTableItem) => {
    setSelectedItem(product)
    setInfoOpen(true)
  }

  const closeInfo = () => {
    setInfoOpen(false)
    setSelectedItem(null)
  }
  const columns = renderProductsColumns(DEFAULT_DENSITY, openInfo, organizations, deals)
  return (
    <>
      <GlobalDataGrid
        columns={columns}
        rows={products}
        apiRef={apiRef}
        context="org_products"
        defaultFilterModel={defaultFilterModel}
        defaultVisibilityModel={defaultVisibilityModel}
        defaultSortModel={defaultSortModel}
        defaultGridDensity={'standard'}
        aggregationModel={{ price: 'sum', netTotal: 'sum', mediaSpend: 'sum' }}
        checkboxSelection={false}
        treeData={false}
        gridContainerSx={{
          position: 'relative',
          ...gridContainerStyles,
          transition: 'all 0.3s ease-in-out',
          height: '100%',
        }}
      />
      {infoOpen && <ProductInfoDialog open={infoOpen} item={selectedItem} onClose={closeInfo} />}
    </>
  )
}

export default OrgProducts
